const local = false;

export const apiUrl = local ? 'http://192.168.0.102:4751/sa/' : 'https://api-dev.mykoodoo.com/sa/';

export const prefix = '/web';

export const googleCloudApiKey = "AIzaSyB_nKKIGIcEJ6ffsVBdYeIstW8KekjVXa8";